import React from 'react'
import { Trans, WithTranslation } from 'react-i18next'
import { FiLayers } from 'react-icons/fi'
import Flex from 'typescript-styled-flex'
import Badge from '../../../../../components/Template/Badge'
import {
  Label,
  Link,
  MenuElement,
} from '../../../../../components/Template/Sidebar'
import { Mixpanel } from '../../../../../utils/Mixpanel'
import { useSelector } from 'react-redux'
import { getUserId } from '../../../../../reducers/userAccount/selectors/userAccount'

function Tasks({
  isSidebarOpen,
  count,
  className,
  size = 1,
}: ITasksProps & WithTranslation) {
  const userId = useSelector(getUserId)

  const logClick = () => {
    Mixpanel.people.increment(userId, 'Tasks Menu Opened', 1)
    Mixpanel.track('Tasks Menu Item Used', {
      'Number Of Tasks': Number(count),
    })
  }

  return (
    <MenuElement
      size={size}
      alignCenter={true}
      className={`${className}-button`}
    >
      <Link size={size} to={'/tasks'} onClick={logClick}>
        <Flex alignCenter={true}>
          <b>
            <FiLayers size={16 * size} />
          </b>
          <Label size={size} primary={true} className={`${className}-label`}>
            <Trans i18nKey={'menu_todolist'}>Zadania</Trans>
          </Label>
          {isSidebarOpen && (
            <Badge id={'badge'} size={size} primary={!!count}>
              <label>{count}</label>
            </Badge>
          )}
        </Flex>
      </Link>
    </MenuElement>
  )
}

export default Tasks

export interface ITasksProps {
  isSidebarOpen?: boolean
  count?: number
  className?: string
  size?: number
}
